import { Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { InputDateProps } from "./types";
import { DateInputField } from "./DateInputField";

export const InputDate: React.FC<InputDateProps> = ({
  name,
  control,
  rules,
  disabled = false,
  placeholder = "DD/MM/YYYY",
  minDate,
  maxDate,
  handleClear = false,
  testId,
  autoComplete,
  id,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <DateInputField
            testId={testId}
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            error={error?.message}
            minDate={minDate}
            maxDate={maxDate}
            handleClear={handleClear}
            autoComplete={autoComplete}
          />
        )}
      />
    </LocalizationProvider>
  );
};
